import React, { useState, useEffect } from 'react';
import { randers3data } from '../../../../../Services/SystemSettings/SystemServices';

function Gst() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const key = 'GST';
        const responseData = await randers3data(key);
        setData(responseData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (key, value) => {
    setData(prevData => {
      const newData = prevData.map(item => {
        if (item.key === key) {
          return { ...item, value };
        }
        return item;
      });
      return newData;
    });
  };

  return (
    <div id="gstdiv">
      <form className="row g-3">
        <div className="col-12">
          <label htmlFor="gst_number" className="form-label">GST number</label>
          <input
            type="text"
            className="form-control"
            id="gst_number"
            name='gst_number'
            value={data?.find(item => item.key === 'gst_number')?.value || ''}
            onChange={(e) => handleInputChange('gst_number', e.target.value)}
          />
          <div className={`gst-err-gst_number invalid-feedback`}>Please provide GST number.</div>
        </div>
        <div className="col-12">
          <label htmlFor="address" className="form-label">Address</label>
          <textarea
            rows="5"
            cols="40"
            type="text"
            className="form-control"
            id="address"
            name="address"
            value={data?.find(item => item.key === 'address')?.value || ''}
            onChange={(e) => handleInputChange('address', e.target.value)}
          ></textarea>
          <div className={`s3-err-address invalid-feedback`}>Please provide Address.</div>
        </div>
        <div className="text-center">
          <button type="Update" id="gstupdate" className="btn btn-primary">Update</button>
          <button type="Reset" className="btn btn-secondary">Reset</button>
        </div>
      </form>
    </div>
  );
}

export default Gst;
